
import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#1976d2', color: 'white', py: 3, textAlign: 'center' }}>
      <Typography variant="body1">
        &copy; Copyright (c) 2023-26 - <a href="https://www.omnevu.com">Omnevu.com</a>
      </Typography>
      <Link
          component={RouterLink}
          to="/legal"
          sx={{ color: 'text.secondary', fontSize: '0.875rem' }}
        >
          Terms & Conditions and Privacy Policy
        </Link>
    </Box>
  );
};

export default Footer;
